import _classCallCheck from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
import { MessageType } from "./IHubProtocol";
import { LogLevel } from "./ILogger";
import { TransferFormat } from "./ITransport";
import { NullLogger } from "./Loggers";
import { TextMessageFormat } from "./TextMessageFormat";
var JSON_HUB_PROTOCOL_NAME = "json";
/** Implements the JSON Hub Protocol. */

export var JsonHubProtocol = /*#__PURE__*/function () {
  function JsonHubProtocol() {
    _classCallCheck(this, JsonHubProtocol);

    /** @inheritDoc */
    this.name = JSON_HUB_PROTOCOL_NAME;
    /** @inheritDoc */

    this.version = 2;
    /** @inheritDoc */

    this.transferFormat = TransferFormat.Text;
  }
  /** Creates an array of {@link @microsoft/signalr.HubMessage} objects from the specified serialized representation.
   *
   * @param {string} input A string containing the serialized representation.
   * @param {ILogger} logger A logger that will be used to log messages that occur during parsing.
   */


  _createClass(JsonHubProtocol, [{
    key: "parseMessages",
    value: function parseMessages(input, logger) {
      // The interface does allow "ArrayBuffer" to be passed in, but this implementation does not. So let's throw a useful error.
      if (typeof input !== "string") {
        throw new Error("Invalid input for JSON hub protocol. Expected a string.");
      }

      if (!input) {
        return [];
      }

      if (logger === null) {
        logger = NullLogger.instance;
      } // Parse the messages


      var messages = TextMessageFormat.parse(input);
      var hubMessages = [];

      var _iterator = _createForOfIteratorHelper(messages),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var message = _step.value;
          var parsedMessage = JSON.parse(message);

          if (typeof parsedMessage.type !== "number") {
            throw new Error("Invalid payload.");
          }

          switch (parsedMessage.type) {
            case MessageType.Invocation:
              this._isInvocationMessage(parsedMessage);

              break;

            case MessageType.StreamItem:
              this._isStreamItemMessage(parsedMessage);

              break;

            case MessageType.Completion:
              this._isCompletionMessage(parsedMessage);

              break;

            case MessageType.Ping:
              // Single value, no need to validate
              break;

            case MessageType.Close:
              // All optional values, no need to validate
              break;

            case MessageType.Ack:
              this._isAckMessage(parsedMessage);

              break;

            case MessageType.Sequence:
              this._isSequenceMessage(parsedMessage);

              break;

            default:
              // Future protocol changes can add message types, old clients can ignore them
              logger.log(LogLevel.Information, "Unknown message type '" + parsedMessage.type + "' ignored.");
              continue;
          }

          hubMessages.push(parsedMessage);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return hubMessages;
    }
    /** Writes the specified {@link @microsoft/signalr.HubMessage} to a string and returns it.
     *
     * @param {HubMessage} message The message to write.
     * @returns {string} A string containing the serialized representation of the message.
     */

  }, {
    key: "writeMessage",
    value: function writeMessage(message) {
      return TextMessageFormat.write(JSON.stringify(message));
    }
  }, {
    key: "_isInvocationMessage",
    value: function _isInvocationMessage(message) {
      this._assertNotEmptyString(message.target, "Invalid payload for Invocation message.");

      if (message.invocationId !== undefined) {
        this._assertNotEmptyString(message.invocationId, "Invalid payload for Invocation message.");
      }
    }
  }, {
    key: "_isStreamItemMessage",
    value: function _isStreamItemMessage(message) {
      this._assertNotEmptyString(message.invocationId, "Invalid payload for StreamItem message.");

      if (message.item === undefined) {
        throw new Error("Invalid payload for StreamItem message.");
      }
    }
  }, {
    key: "_isCompletionMessage",
    value: function _isCompletionMessage(message) {
      if (message.result && message.error) {
        throw new Error("Invalid payload for Completion message.");
      }

      if (!message.result && message.error) {
        this._assertNotEmptyString(message.error, "Invalid payload for Completion message.");
      }

      this._assertNotEmptyString(message.invocationId, "Invalid payload for Completion message.");
    }
  }, {
    key: "_isAckMessage",
    value: function _isAckMessage(message) {
      if (typeof message.sequenceId !== 'number') {
        throw new Error("Invalid SequenceId for Ack message.");
      }
    }
  }, {
    key: "_isSequenceMessage",
    value: function _isSequenceMessage(message) {
      if (typeof message.sequenceId !== 'number') {
        throw new Error("Invalid SequenceId for Sequence message.");
      }
    }
  }, {
    key: "_assertNotEmptyString",
    value: function _assertNotEmptyString(value, errorMessage) {
      if (typeof value !== "string" || value === "") {
        throw new Error(errorMessage);
      }
    }
  }]);

  return JsonHubProtocol;
}();